import LayoutDelete from "./LayoutDelete";

export default LayoutDelete;
